import {
  fiscalPeriodsViewColumns,
  fiscalPeriodsSearchSchema,
  mapFiscalPeriodsViewQuery,
} from "./FiscalPeriodsView.default";
import ManagedGridView from "../controls/ManagedGridView";
import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import { PaginationInput } from "../repository/data.default";
import { getCompanyFiscalPeriods } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

export interface FiscalPeriodsViewProps {
  readonly companyUid: string;
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function FiscalPeriodsView(props: FiscalPeriodsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  // Always scope to this company's periods (admins see all otherwise) by injecting a companyUid
  // condition ahead of any search-form conditions — so initial load + searches stay company-scoped.
  const scopedRequest = createGridRequest(
    (input: PaginationInput) =>
      getCompanyFiscalPeriods({
        ...input,
        searchQuery: {
          conditions: [
            { field: "companyUid", operation: QueryOperation.Equal, values: [props.companyUid] },
            ...(input.searchQuery?.conditions ?? []),
          ],
        },
      }),
    { retry: true },
  );

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={fiscalPeriodsViewColumns}
      schema={fiscalPeriodsSearchSchema}
      mapQuery={mapFiscalPeriodsViewQuery}
      onSearch={props.onSearch}
      request={scopedRequest}
      actions={[
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("CompanyFiscalPeriods", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("CompanyFiscalPeriods", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default FiscalPeriodsView;
